import { ActionType } from "../interfaces/api/actionType";

export const GetResponsibilities: ActionType = {
  FAILURE: "GET_RESPONSIBILITIES_FAILURE",
  REQUEST: "GET_RESPONSIBILITIES_REQUEST",
  SUCCESS: "GET_RESPONSIBILITIES_SUCCESS",
};
